import {
	SET_CUSTOMERS,
	SET_CUSTOMER,
	CLEAR_CUSTOMERS,
	CLEAR_CUSTOMER,
	ADD_CUSTOMER,
	UPDATE_CUSTOMER,
	REMOVE_CUSTOMER,
} from './actionTypes';

export const customer = (state = {}, action) => {
	switch (action.type) {
		case SET_CUSTOMER:
			return action.payload;
		case UPDATE_CUSTOMER:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_CUSTOMER:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_CUSTOMERS:
			return action.payload;
		case ADD_CUSTOMER:
			return [...state, action.payload];
		case UPDATE_CUSTOMER:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_CUSTOMER:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_CUSTOMERS:
			return [];
		default:
			return state;
	}
};
